<template>
  <div class="arg-btn">
    <van-icon v-if="editable&&agrData" name="clear" class="close-btn" @click="$emit('remove')" />
    <template v-if="agrData">
      <div class="name">
        <svg-icon
          :icon-class="agrData.type|getAgrOption|icon"
          :style="agrData.type|getAgrOption|color"
        />
        <span>{{ agrData.name }}</span>
      </div>
      <div class="manufacturer">
        {{ agrData.factory }}
      </div>
    </template>
    <template v-else>
      <span class="select-btn" @click="$emit('add')">选择农资</span>
    </template>
  </div>
</template>

<script>
import { agrTypeOptions } from '@/constant/common'

export default {
  name: 'AgrBox',
  filters: {
    getAgrOption(type) {
      switch (type) {
        case '种子(苗)':
          return agrTypeOptions['seed']
        case '农药':
          return agrTypeOptions['pesticide']
        case '肥料':
          return agrTypeOptions['fertilizer']
        case '饲料':
          return agrTypeOptions['feed']
        case '兽药':
          return agrTypeOptions['drug']
        default:
          return agrTypeOptions['seed']
      }
    },
    icon(val) {
      return val.icon
    },
    color(val) {
      return `color:${val.color};`
    }
  },
  props: {
    agrData: {
      type: Object,
      default() {
        return undefined
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
.arg-btn {
  position: relative;
  display: inline-block;
  padding: 12px 16px;
  background: #F5F7FA;
  border-radius: 2px;
  color: #333;
  line-height: normal;
  .close-btn {
    position: absolute;
    right: -8px;
    top: -8px;
    color: #C9D0DB;
  }
  .name {
    font-size: 14px;
    .svg-icon {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .manufacturer {
    font-size: 12px;
    line-height: 2;
  }
  .select-btn {
    font-size: 12px;
    color: @primary-color;
  }
}
</style>
